
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M9.99 0C4.484 0 0 4.484 0 9.99 0 15.516 4.484 20 9.99 20S20 15.516 20 9.99C20.001 4.484 15.496 0 9.99 0zm6.827 14.715c-2.181.24-4.544.3-6.827.3-2.282 0-4.644-.06-6.847-.3-.62-.06-.941-.22-1.022-.881-.12-1.261-.12-2.543-.12-3.844 0-1.28 0-2.563.12-3.824.08-.66.401-.82 1.022-.881 2.202-.24 4.565-.3 6.847-.3 2.283 0 4.644.06 6.827.3.641.06.961.22 1.042.881.1 1.261.1 2.543.1 3.824 0 1.3 0 2.583-.1 3.844-.08.66-.401.82-1.042.881z"}}),_c('path',{attrs:{"d":"M5.946 9.99A4.033 4.033 0 019.99 5.946a4.032 4.032 0 014.044 4.044c0 2.223-1.761 4.065-4.044 4.065-2.282 0-4.044-1.842-4.044-4.065z"}})])])
          )
        }
      }
    